import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref } from 'vue';
import Menu from 'primevue/menu';
import IconButton from './IconButton.vue';
const kbUrl = 'https://kb.apx.me/support/login';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SupportMenu',
    setup(__props) {
        const newUserUrl = `${window.location.protocol}//${window.location.hostname}/apx/newUserRequest/index.html`;
        const menuRef = ref();
        const containerRef = ref();
        const menuItems = ref([
            {
                label: 'Knowledge base',
                command: () => window.open(kbUrl, '_blank'),
            },
            {
                label: 'New user request',
                command: () => window.open(newUserUrl, '_blank'),
            },
        ]);
        const toggleMenu = (e) => menuRef.value.toggle(e);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    ref_key: "containerRef",
                    ref: containerRef,
                    class: "container",
                    onClick: toggleMenu
                }, [
                    _createVNode(IconButton, { "icon-name": "heart" })
                ], 512),
                _createVNode(_unref(Menu), {
                    ref_key: "menuRef",
                    ref: menuRef,
                    model: menuItems.value,
                    popup: true
                }, null, 8, ["model"])
            ], 64));
        };
    }
});
